module.exports = __webpack_public_path__ + "static/img/data_line_yellow.40b97ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/data_line_yellow.png
// module id = jWbC
// module chunks = 2